import { SNSTypes } from 'config/consts';
import React from 'react';
export type SNS = keyof typeof SNSTypes;

export const snsToString = (sns: SNS) => {
  switch (sns) {
    case 'twitter':
      return 'twitter';
  }
};

export const SNSIcon = ({
  sns,
  className,
}: {
  sns: SNS;
  className?: string;
}) => {
  return (
    <>
      <div className={`icon-${sns} text-${sns} ${className ?? ''}`}></div>
    </>
  );
};
